/* ==========================================================================
   Blessed Bangles — bb-wheel.js  (Gift wheel popup)
   Config comes from sections/bb-wheel.liquid as JSON. Rules:
   - auto-open once per session (sessionStorage), after delay / scroll / exit intent
   - never again after an email has been captured (localStorage)
   - 14-day cooldown after a close without email (localStorage)
   - manual open via any [data-wheel-open] element, always allowed
   - prizes are weighted; a prize with no code is a "no prize" slice
   - email goes to Klaviyo (client subscriptions API) when company+list ids exist,
     otherwise to Shopify's own customer form (/contact, form_type=customer)
   ========================================================================== */
(function () {
  'use strict';
  var BB = (window.BB = window.BB || {});
  var root = document.querySelector('[data-wheel-root]'); if (!root) return;
  var cfgEl = root.querySelector('[data-wheel-config]'); if (!cfgEl) return;
  var C; try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!C.enabled) return;

  var K = { email: 'bb_wheel_email', closed: 'bb_wheel_closed_at', session: 'bb_wheel_shown' };
  var ls = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
  var ss = { get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} } };

  var modal = root.querySelector('[data-wheel-modal]');
  var wheelEl = root.querySelector('[data-wheel-svg]');
  var form = root.querySelector('[data-wheel-form]');
  var emailInput = root.querySelector('[data-wheel-email]');
  var spinBtn = root.querySelector('[data-wheel-spin]');
  var err = root.querySelector('[data-wheel-error]');
  var stepForm = root.querySelector('[data-wheel-step="form"]');
  var stepResult = root.querySelector('[data-wheel-step="result"]');
  var prizes = (C.prizes || []).filter(function (p) { return p.label; });
  if (!prizes.length) return;
  var n = prizes.length, seg = 360 / n, spinning = false, rotation = 0, autoOpened = false;

  /* ---------- draw wheel ---------- */
  function polar(cx, cy, r, a) { var rad = (a - 90) * Math.PI / 180; return [cx + r * Math.cos(rad), cy + r * Math.sin(rad)]; }
  function draw() {
    var cx = 150, cy = 150, r = 146, html = '';
    prizes.forEach(function (p, i) {
      var a0 = i * seg, a1 = (i + 1) * seg;
      var p0 = polar(cx, cy, r, a0), p1 = polar(cx, cy, r, a1);
      var large = seg > 180 ? 1 : 0;
      var fill = p.color || (i % 2 ? C.colorB : C.colorA);
      html += '<path d="M' + cx + ' ' + cy + ' L' + p0[0].toFixed(2) + ' ' + p0[1].toFixed(2) + ' A' + r + ' ' + r + ' 0 ' + large + ' 1 ' + p1[0].toFixed(2) + ' ' + p1[1].toFixed(2) + ' Z" fill="' + fill + '" stroke="#fff" stroke-width="2"/>';
      var mid = a0 + seg / 2, tp = polar(cx, cy, r * 0.62, mid);
      var textColor = p.textColor || C.textColor || '#1a1b18';
      html += '<text x="' + tp[0].toFixed(2) + '" y="' + tp[1].toFixed(2) + '" transform="rotate(' + mid + ' ' + tp[0].toFixed(2) + ' ' + tp[1].toFixed(2) + ')" text-anchor="middle" dominant-baseline="middle" font-size="' + (n > 6 ? 9 : 11) + '" font-weight="700" fill="' + textColor + '">' + BB.escape(p.label).toUpperCase() + '</text>';
    });
    html += '<circle cx="' + cx + '" cy="' + cy + '" r="22" fill="#fff" stroke="' + (C.colorA || '#d1b24a') + '" stroke-width="4"/>';
    wheelEl.innerHTML = html;
  }

  /* ---------- weighted pick ---------- */
  function pick() {
    var total = prizes.reduce(function (s, p) { return s + (Number(p.weight) || 0); }, 0) || n;
    var r = Math.random() * total, acc = 0;
    for (var i = 0; i < n; i++) { acc += Number(prizes[i].weight) || (total / n); if (r < acc) return i; }
    return n - 1;
  }

  /* ---------- open / close ---------- */
  function canAutoOpen() {
    if (ls.get(K.email)) return false;
    if (ss.get(K.session)) return false;
    var closed = Number(ls.get(K.closed) || 0);
    if (closed && Date.now() - closed < (Number(C.cooldownDays) || 14) * 864e5) return false;
    return true;
  }
  function open(manual) {
    if (!manual && !canAutoOpen()) return;
    if (!manual) { ss.set(K.session, '1'); autoOpened = true; }
    root.hidden = false; root.classList.add('is-open'); document.body.classList.add('bb-lock');
    BB.track('bb_wheel_open', { manual: !!manual });
    setTimeout(function () { emailInput && emailInput.focus(); }, 200);
  }
  function close() {
    root.classList.remove('is-open'); root.hidden = true; document.body.classList.remove('bb-lock');
    if (!ls.get(K.email)) ls.set(K.closed, String(Date.now()));
  }
  window.BBWheel = { open: open, close: close };
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wheel-open]'); if (t) { e.preventDefault(); open(true); return; }
    t = e.target.closest('[data-wheel-close]'); if (t) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  /* ---------- subscribe ---------- */
  function subscribeKlaviyo(email) {
    var body = { data: { type: 'subscription', attributes: { custom_source: C.source || 'Gift wheel', profile: { data: { type: 'profile', attributes: { email: email, properties: { bb_wheel: true } } } } }, relationships: { list: { data: { type: 'list', id: C.klaviyoList } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(C.klaviyoCompany), { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body) });
  }
  function subscribeShopify(email) {
    var fd = new FormData(); fd.append('form_type', 'customer'); fd.append('utf8', '✓'); fd.append('contact[email]', email); fd.append('contact[tags]', 'newsletter,gift-wheel');
    return fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' });
  }
  function subscribe(email) {
    var p = (C.klaviyoCompany && C.klaviyoList) ? subscribeKlaviyo(email) : subscribeShopify(email);
    return p.catch(function () { /* never block the prize on a network hiccup */ });
  }

  /* ---------- spin ---------- */
  function spin(e) {
    e.preventDefault(); if (spinning) return;
    var email = (emailInput.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.hidden = false; err.textContent = C.emailError || 'Please enter a valid email'; emailInput.focus(); return; }
    err.hidden = true; spinning = true; spinBtn.disabled = true; spinBtn.classList.add('is-loading');
    var idx = pick(), prize = prizes[idx];
    var jitter = (Math.random() - 0.5) * seg * 0.6;
    var target = 360 * (5 + Math.floor(Math.random() * 3)) + (360 - (idx * seg + seg / 2)) + jitter;
    rotation += target;
    wheelEl.style.transition = 'transform 5.2s cubic-bezier(.12,.75,.2,1)';
    wheelEl.style.transform = 'rotate(' + rotation + 'deg)';
    subscribe(email).then(function () { ls.set(K.email, email); });
    setTimeout(function () { showResult(prize, email); spinning = false; spinBtn.classList.remove('is-loading'); }, 5400);
    BB.track('bb_wheel_spin', { prize: prize.label, code: prize.code || '' });
  }

  function showResult(prize, email) {
    stepForm.hidden = true; stepResult.hidden = false;
    var win = !!prize.code;
    root.querySelector('[data-result-title]').textContent = win ? (C.winTitle || 'You won!') : (C.loseTitle || 'Not this time');
    root.querySelector('[data-result-prize]').textContent = prize.label;
    root.querySelector('[data-result-desc]').textContent = win ? (prize.description || '') : (C.loseText || 'Your welcome gift is still in your inbox.');
    var codeWrap = root.querySelector('[data-result-code]');
    codeWrap.hidden = !win;
    if (win) {
      root.querySelector('[data-code-value]').textContent = prize.code;
      var copy = root.querySelector('[data-copy]'); if (copy) copy.dataset.copy = prize.code;
      var apply = root.querySelector('[data-apply-code]');
      if (apply) apply.href = '/discount/' + encodeURIComponent(prize.code) + '?redirect=' + encodeURIComponent(prize.redirect || C.redirect || '/');
      var fine = root.querySelector('[data-result-fine]');
      if (fine) fine.textContent = prize.minOrder ? (C.minOrderText || 'Valid on orders from [amount]').replace(/\[amount\]|\{\{\s*amount\s*\}\}/g, prize.minOrder) : (C.fineText || '');
    }
    var mailNote = root.querySelector('[data-result-email]'); if (mailNote) mailNote.textContent = (C.emailedText || 'We also sent it to [email]').replace(/\[email\]|\{\{\s*email\s*\}\}/g, email);
  }

  /* ---------- triggers ---------- */
  form && form.addEventListener('submit', spin);
  draw();
  var T = C.triggers || {};
  if (canAutoOpen()) {
    if (T.delay > 0) setTimeout(function () { if (!autoOpened) open(false); }, T.delay * 1000);
    if (T.scroll > 0) {
      var onScroll = function () { var pct = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100; if (pct >= T.scroll) { window.removeEventListener('scroll', onScroll); if (!autoOpened) open(false); } };
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    if (T.exit) {
      document.addEventListener('mouseleave', function (e) { if (e.clientY <= 0 && !autoOpened) open(false); });
    }
  }
})();
